import { otmmUrlEncoded } from '../../otmm/apis/otmm';
import isSuccessfulResponse from './isSuccessfulResponse';

const unlockAsset = async (id) => {
  const params = new URLSearchParams();
  params.append('action', 'unlock');

  const response = await otmmUrlEncoded.put(`assets/${id}/state`, params);

  return isSuccessfulResponse(id, response);
};

export default unlockAsset;
